import { render, staticRenderFns } from "./lookTag.vue?vue&type=template&id=31a9e595&scoped=true&"
import script from "./lookTag.vue?vue&type=script&lang=js&"
export * from "./lookTag.vue?vue&type=script&lang=js&"
import style0 from "./lookTag.vue?vue&type=style&index=0&id=31a9e595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a9e595",
  null
  
)

export default component.exports